module.exports = "<!-- <div class=\"sidebar-header\"></div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// C:/repos/Tulaima/Tulaima-ng/src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module id = ../../../../../src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module chunks = main